export const frData = `
  <div class="paragraph">
    <div class="page-title">Foire aux questions sur le programme de reprise (Trade-In)</div>
  </div>
  <div class="paragraph">
    <div class="title">Qui peut participer au programme de reprise?</div>
    <div class="text-box">
      <div class="text">
        Le service de reprise est disponible pour toute personne âgée de 18 ans ou plus, résidant légalement dans un État membre de l'Union européenne ou au Royaume-Uni.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que dois-je faire avant d'envoyer mon ancien appareil?</div>
    <div class="text-box">
      <div class="text">
        Avant d'envoyer votre appareil:<br>
        • Supprimez toutes les données personnelles et retirez tout code PIN, mot de passe ou schéma de verrouillage d'écran.<br>
        • Effectuez une réinitialisation complète aux paramètres d'usine.<br>
        • Sur iPhone: déconnectez votre compte iCloud en désactivant la fonction « Localiser mon iPhone ».<br>
        • Sur Android: supprimez votre compte Google (Paramètres > Comptes > Google > Supprimer le compte).<br>
        Cela garantit que l'appareil n'est plus lié à votre compte et protège vos informations personnelles.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Comment puis-je envoyer mon ancien appareil?</div>
    <div class="text-box">
      <div class="text">
        <strong>Emballage:</strong> utilisez une boîte solide et opaque (non transparente) et ajoutez une protection interne (papier bulle ou équivalent) pour éviter tout dommage pendant le transport.<br>
        <strong>Étiquette d'expédition:</strong> si vous ne disposez pas du matériel d'emballage approprié, vous pouvez en demander sur le point de dépôt au moment de remettre votre colis.<br>
        <strong>Documentation:</strong> imprimez, remplissez et signez la Déclaration d'honnêteté, puis placez-la dans le colis avant de le fermer.<br>
        <strong>Fermeture sécurisée:</strong> assurez-vous que le colis soit correctement scellé et fixez l'étiquette d'expédition gratuite dans un endroit bien visible.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Quels types d'appareils ne sont pas acceptés?</div>
    <div class="text-box">
      <div class="text">
        Nous n'acceptons pas les appareils qui:<br>
        • sont verrouillés par un opérateur (SIM-lock);<br>
        • ne s'allument pas ou ne se chargent pas;<br>
        • ne peuvent pas se connecter via Bluetooth ou Wi-Fi;<br>
        • présentent une panne interne ou de carte mère;<br>
        • sont encore liés à un compte iCloud ou Google;<br>
        • sont contrefaits ou des copies;<br>
        • sont gravement endommagés.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Dois-je envoyer les accessoires (chargeur, câble, etc.)?</div>
    <div class="text-box">
      <div class="text">
        Ce n'est pas obligatoire, mais recommandé. Inclure les accessoires contribue à la durabilité et à une réutilisation appropriée.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Dois-je envoyer les écouteurs?</div>
    <div class="text-box">
      <div class="text">
        Non. Pour des raisons d'hygiène, les écouteurs seront écartés et ne seront pas pris en compte lors de l'évaluation.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Dois-je envoyer la facture d'achat?</div>
    <div class="text-box">
      <div class="text">
        Non, la facture n'est pas requise pour l'évaluation ni pour le paiement. Vous pouvez la conserver pour vos propres dossiers.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Comment mon ancien appareil est-il évalué?</div>
    <div class="text-box">
      <div class="text">
        Nous utilisons un logiciel de diagnostic certifié et procédons à une inspection manuelle dans notre centre d'évaluation pour déterminer l'état de votre appareil. Toutes les procédures d'évaluation et de traitement des données sont conformes au Règlement général sur la protection des données (RGPD – UE 2016/679), garantissant la sécurité et la confidentialité de vos informations.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que se passe-t-il si l'état que j'ai indiqué ne correspond pas à votre évaluation?</div>
    <div class="text-box">
      <div class="text">
        S'il existe des différences entre l'état déclaré et notre évaluation, nous vous enverrons un e-mail contenant:<br>
        • Une offre mise à jour basée sur l'inspection réelle.<br>
        • Le rapport de diagnostic et les raisons de la différence constatée.<br><br>
        Vous pouvez accepter ou refuser l'offre:<br>
        • Si vous acceptez, la reprise sera finalisée et vous recevrez le paiement sur votre compte bancaire dans un délai de 3 jours ouvrables.<br>
        • Si vous refusez, le processus de retour dépendra de votre lieu de résidence:<br>
        &nbsp;&nbsp;◦ Pour les clients en Espagne: l'expédition de retour sera gratuite et prise en charge par Danghuan Europe S.L.<br>
        &nbsp;&nbsp;◦ Pour les clients hors d'Espagne: des frais de retour s'appliquent, jusqu'à un maximum de 22 EUR / 19 GBP / 165 DKK / 245 SEK (TVA comprise).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que se passe-t-il si je ne réponds pas à l'offre mise à jour?</div>
    <div class="text-box">
      <div class="text">
        Si aucune réponse n'est reçue dans un délai de 30 jours calendaires à compter de la notification, l'offre révisée sera automatiquement considérée comme refusée.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que devient-il de mes données personnelles?</div>
    <div class="text-box">
      <div class="text">
        Vous devez supprimer toutes les données avant d'envoyer votre ancien appareil.<br>
        Si nous détectons des données restantes, nous suspendrons le processus et vous contacterons pour les effacer. Nous respectons pleinement le RGPD (Règlement UE 2016/679).
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Qui prend en charge les frais d'expédition?</div>
    <div class="text-box">
      <div class="text">
        La première expédition est toujours gratuite.<br><br>
        Si vous refusez l'offre mise à jour:<br>
        • Pour les clients en Espagne: le retour est gratuit et pris en charge par Danghuan Europe S.L.<br>
        • Pour les clients hors d'Espagne: des frais de retour s'appliquent, jusqu'à un maximum de 22 EUR / 19 GBP / 165 DKK / 245 SEK (TVA comprise).<br>
        • Les frais doivent être réglés dans un délai de 5 jours calendaires après réception de la demande de paiement.<br>
        • Une fois le paiement confirmé (le cas échéant), Danghuan organisera l'expédition de retour à votre adresse d'origine.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Que se passe-t-il si mon colis est perdu pendant le transport?</div>
    <div class="text-box">
      <div class="text">
        Si votre appareil est perdu pendant le transport, Danghuan Europe S.L. vous assistera dans la procédure officielle de réclamation auprès du transporteur.<br><br>
        Un envoi est considéré comme perdu s'il n'a pas été suivi, confirmé ou reçu par Danghuan dans un délai de 15 jours calendaires après sa remise au transporteur.<br><br>
        • Vous devez utiliser l'étiquette d'expédition prépayée autorisée par Danghuan.<br>
        • Les réclamations doivent être déposées dans les délais impartis selon le transporteur utilisé.<br>
        • Danghuan assistera à l'enquête du transporteur, qui dure généralement 30 à 60 jours.<br><br>
        Si la perte est confirmée, l'indemnisation ne dépassera pas la valeur finale estimée de reprise de l'appareil.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Quand recevrai-je le paiement?</div>
    <div class="text-box">
      <div class="text">
        Une fois l'offre finale acceptée, le paiement sera effectué par virement bancaire dans un délai de 3 jours ouvrables. Veuillez vous assurer que votre IBAN et votre numéro d'identification personnel sont corrects et correspondent au titulaire du compte.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Est-il obligatoire de fournir mon numéro d'identification personnel?</div>
    <div class="text-box">
      <div class="text">
        Oui. Pour traiter le paiement, vous devez fournir un numéro d'identification personnel valide, sans espaces ni caractères spéciaux, correspondant au titulaire du compte IBAN.
      </div>
    </div>
  </div>
  <div class="paragraph">
    <div class="title">Puis-je annuler ma demande de reprise?</div>
    <div class="text-box">
      <div class="text">
        Oui, si votre ancien appareil n'a pas encore été payé. Veuillez nous contacter dès que possible à l'adresse <span class="email">oppo@danghuan.eu</span>.<br><br>
        Si vous avez déjà envoyé votre appareil, contactez-nous dans un délai de 48 heures; sinon, le processus de recyclage se poursuivra normalement.
      </div>
    </div>
  </div>
`;